var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-report",
    attrs: {
      isCustomizable: _vm.settings.isCustomizable,
      loading: _vm.loading,
      type: _vm.type,
      showHeader: !_vm.error
    },
    on: {
      "edit-card": _vm.toggleSettingsForm,
      "hide-card": function($event) {
        return _vm.$emit("hide-card", _vm.settings.type)
      },
      "refresh-card": _vm.toggleReport
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function() {
          return undefined
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _vm.error
              ? _c("error-card", {
                  attrs: {
                    placeHolderText: _vm.$t.__(
                      "dashboard.cards.ReportCard.service_not_available_try_again_later"
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.error && _vm.tooLongToFetchData
              ? _c("error-card", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "placeholder",
                        fn: function() {
                          return [
                            _c("p", {
                              staticClass:
                                "error-card--timeout dinlineb acenter fs-3 typographies-paragraph-medium-semibold",
                              domProps: {
                                innerHTML: _vm._s(_vm.placeholderFetchFail)
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1809720720
                  )
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.error &&
            !_vm.tooLongToFetchData &&
            _vm.showCumulCard &&
            _vm.data
              ? [
                  _c("luzmo-embed-dashboard", {
                    ref: "dashboardInstance",
                    staticClass: "cumul-embed",
                    attrs: {
                      dashboardId: _vm.data.dashboard,
                      authKey: _vm.data.key,
                      authToken: _vm.data.token,
                      language: _vm.customSettings.language
                    },
                    on: { itemsRendered: _vm.handleRendered }
                  })
                ]
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }